module.exports = __webpack_public_path__ + "static/media/吹奏楽部展示.819e427c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/吹奏楽部展示.png
// module id = 317
// module chunks = 10